import { Table } from 'antd';
import React from 'react'

const TableViewActiveKanban = ({ getActiveKanban, sizeData }) => {

  const columns = [
    {
      title: 'S.No',
      key: 'serial',
      render: (text, record, index) => index + 1,
    },
    {
      title: 'Kanban Number',
      dataIndex: 'kb_number',
      key: 'kb_number',
    },
    {
      title: 'PO No',
      dataIndex: 'po_no',
      key: 'po_no',
    },
    {
      title: 'Quantity',
      dataIndex: 'quantity',
      key: 'quantity',
    },
    {
      title: 'Color',
      dataIndex: 'color',
      key: 'color',
    },
  ];

  const expandColumns = [
    {
      title: 'Size',
      dataIndex: 'size',
      key: 'size',
    },
    {
      title: 'Quantity',
      dataIndex: 'size_qty',
      key: 'size_qty',
    },
  ];

  // console.log(sizeData);
  
  const expandedRowRender = (record) => {
    const filteredSizeData = sizeData.filter(item => item.kb_number === record.kb_number);
    return <Table columns={expandColumns} dataSource={filteredSizeData} pagination={false} rowKey="size" />;
  };

  return (
    <>
      <Table
        size='small'
        dataSource={getActiveKanban}
        columns={columns}
        pagination={false}
        expandable={{
          expandedRowRender,
        }}
        rowKey="kb_number"
      />
    </>
  )
}

export default TableViewActiveKanban